const pageview = (name, props = {}) => {
  window?.rudderanalytics?.page(name, props);
};

const identify = (userId, traits = {}) => {
  window?.rudderanalytics?.identify(userId, traits);
};

const BUSINESS_EVENT_NAME = 'business_event';

function event(name, props = {}) {
  window?.rudderanalytics?.track(BUSINESS_EVENT_NAME, {
    event_name: name,
    business_event_payload: props,
  });
}

export const Rudderstack = {
  pageview,
  identify,
  event,
};
